
import { CalendarIcon, RefreshCwIcon, ChevronDownIcon } from 'vue-feather-icons'
import { loadMomentTimeZone, loadLuxon } from '~/fc/ExternalScripts'

export default {
  name: 'TimeConverter',
  components: {
    CalendarIcon,
    RefreshCwIcon,
    ChevronDownIcon,
    Datetime: () => import(/* webpackChunkName: "datetime" */ 'vue-datetime/src/Datetime.vue'),
    ButtonCopy: () => import('../../../components/ui/form/buttons/ButtonCopy')
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    source: {
      default: null,
      required: true
    },
    // eslint-disable-next-line vue/require-prop-types
    target: {
      default: null,
      required: true
    },
    // eslint-disable-next-line vue/require-prop-types
    sourceLists: {
      default: [],
      required: true
    },
    // eslint-disable-next-line vue/require-prop-types
    targetLists: {
      default: [],
      required: true
    }
  },
  data: () => ({
    datetime: '',
    mainCardText: '',
    baseUrl: '',
    fullDateFormat: 'MMMM Do YYYY, h:mm:ss a',
    timer: null,
    hours: [],
    moment: null,
    luxon: null
  }),
  computed: {
    info () { return this.$store.state.info },
    sourceTime () {
      return this.moment && this.moment.tz ? this.moment.tz(this.datetime, this.source.name).format('hh:mm a') : ''
    },
    targetTime () {
      return this.moment && this.moment.tz ? this.moment.tz(this.datetime, this.target.name).format('hh:mm a') : ''
    },
    activeSource () {
      return this.moment && this.moment.tz ? this.moment.tz.zone(this.source.name).abbr(this.moment(this.datetime)) : ''
    },
    activeTarget () {
      return this.moment && this.moment.tz ? this.moment.tz.zone(this.target.name).abbr(this.moment(this.datetime)) : ''
    },
    copyLink () {
      return this.baseUrl + '?share=' + new Date(this.datetime).getTime()
    }
  },
  mounted () {
    if(process.client) {
      loadMomentTimeZone((moment) => {
        this.moment = moment
        loadLuxon((luxon) => {
          this.luxon = luxon
          this.translateDatePicker()
          this.initiateConverter()
        })
      })
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    translateDatePicker () {
      this.luxon.Settings.defaultLocale = this.$i18n.locale
      const self = this
      setTimeout(() => {
        const datePickers = document.getElementsByClassName('clickable')
        if (datePickers && datePickers.length) {
          datePickers.forEach((datePicker) => {
            datePicker.addEventListener('click', () => {
              setTimeout(() => {
                document.getElementsByClassName('vdatetime-popup__actions__button--cancel')[0].innerText = self.$t('cancel')
                document.getElementsByClassName('vdatetime-popup__actions__button--confirm')[0].innerText = self.$t('ok')
              }, 100)
            })
          })
        }
      }, 500)
    },
    rotateRefreshIcon (icon) {
      const refreshIcon = document.getElementById(icon)
      if (refreshIcon) {
        refreshIcon.classList.add('rotate-once')
        setTimeout(() => { refreshIcon.classList.remove('rotate-once') }, 500)
      }
    },
    // eslint-disable-next-line require-await
    async initiateConverter (icon) {
      this.rotateRefreshIcon(icon)
      const DateTime = this.luxon.DateTime
      window.DateTime = DateTime
      this.baseUrl = location.origin + this.$route.path
      if (this.$route.query.share) {
        this.datetime = new Date(parseInt(this.$route.query.share)).toISOString()
      } else {
        // eslint-disable-next-line new-cap
        this.datetime = new DateTime.local().toString()
      }
      this.timer = setInterval(() => {
        const contentMarkUp = this.info.main_card_text && this.info.main_card_text[0] ? this.info.main_card_text[0].content : ''
        this.mainCardText = contentMarkUp.replace(
            /S_FORMATED/g,
            this.moment.tz(this.moment(), this.source.name).format(this.fullDateFormat)
          )
          .replace(
            /T_FORMATED/g,
            this.moment.tz(this.moment(), this.target.name).format(this.fullDateFormat)
          )
      }, 1000)
      for (let i = 0; i < 24; i++) {
        this.hours.push(i)
      }
    },
    useCurrentTime () {
      this.datetime = new Date().toISOString()
    },
    formatTime (time, abbr) {
      if (time === '12:00 am') {
        return `12:00 am ${abbr} (${this.$t('midnight')})`
      } else if (time === '12:00 pm') {
        return `12:00 pm ${abbr} (${this.$t('noon')})`
      }
      return `${time} ${abbr}`
    }
  }
}
